<template>

</template>

<script>
import { autoLogin } from "@/api/unifysign/sign";
import { setTenantIdApi } from "@/api/home";
import { setToken, removeToken } from "@/utils/auth";

export default {
    data() {
        return {
            sid: ""
        };
    },
    created() {
        removeToken();
        this.sid = this.$route.query.sid;
        this.handleAutoLogin();
    },
    methods: {
        handleAutoLogin() {
            autoLogin({
                sid: this.sid
            }).then(res => {
                if (res.code == 200) {
                    const tenantId = res.data.tenantId;
                    const returnUrl = res.data.returnUrl;
                    setToken(res.data.token);
                    setTenantIdApi({ tenantId: tenantId }).then((res) => {
                        if (res.code != 200) {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "warning",
                            });
                        } else {
                            this.$store.commit("SET_CURRENT_SPACE", { tenantId: tenantId });
                            window.location.href = returnUrl;
                        }
                    })
                };
            })

        }
    }
}
</script>

